export const MS_ONE_MIN = 1000 * 60;
export const MS_ONE_HOUR = MS_ONE_MIN * 60;
export const MS_24_HOURS = MS_ONE_HOUR * 24;
export const MS_12_HOURS = MS_ONE_HOUR * 12;
export const TIME_TO_REFRESH = MS_ONE_MIN * 20;
export const TRACKING_INTERVAL = 3000;
export const ONE_DAY_MILISECONDS = 24 * 60 * 60 * 1000;
export const VIEW_DESKTOP_LIMIT = 920;
export const VIEW_MOBILE_LIMIT = 575;
export const VIEW_MOBILE_SMALL_LIMIT = 340;

export const ASCCI_HIDDEN = String.fromCharCode(160);
